import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'lib-flexible/flexible'
import './utils/axios'
// import * as shareInfo from './api/weixinShare'
import shareInfo from './api/weixinShare';
shareInfo.init({
  img:'https://www.nbd.com.cn/corp/NBD_ad/jue-share.jpg',
  title:'每经APP掘金投资大赛',
  desc:'零投入模拟炒股，正收益即可获奖，投资小白也能赢！',
  shareURL:'https://www.nbd.com.cn/corp/juejin-share/dist/index.html'
})
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
